export const SL_PERMISSION_REQUEST_KEY = 'SL_PERMISSION_REQUEST';
